import { supabase } from "@foundation/utils/supabaseClient";
import { getActiveWorkspaceId } from "../../../../header/activeWorkspace";
import type { ClientRecord, ClientFieldsPayload } from "../types/clientTypes";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: import.meta.env is provided by Vite at build time
const API_BASE_URL = (import.meta.env?.VITE_API_URL as string) || 'http://localhost:3001';

const getHeaders = async (): Promise<Record<string, string>> => {
  const { data: { user } } = await supabase.auth.getUser();
  const organisationId = getActiveWorkspaceId();
  return {
    'Content-Type': 'application/json',
    ...(user?.id ? { 'x-user-id': user.id } : {}),
    ...(organisationId ? { 'x-org-id': organisationId } : {}),
  };
};

export const clientService = {
  getClients: async (): Promise<ClientRecord[]> => {
    const res = await fetch(`${API_BASE_URL}/api/revisr/clients`, { headers: await getHeaders() });
    if (!res.ok) throw new Error(`Failed to fetch clients: ${res.status}`);
    return res.json();
  },

  getClient: async (id: string): Promise<ClientRecord> => {
    const res = await fetch(`${API_BASE_URL}/api/revisr/clients/${id}`, { headers: await getHeaders() });
    if (!res.ok) throw new Error(`Failed to fetch client: ${res.status}`);
    return res.json();
  },

  createClient: async (payload: ClientFieldsPayload): Promise<ClientRecord> => {
    const res = await fetch(`${API_BASE_URL}/api/revisr/clients`, {
      method: 'POST',
      headers: await getHeaders(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`Failed to create client: ${res.status}`);
    return res.json();
  },

  updateClient: async (id: string, payload: Partial<ClientFieldsPayload>): Promise<ClientRecord> => {
    const res = await fetch(`${API_BASE_URL}/api/revisr/clients/${id}`, {
      method: 'PATCH',
      headers: await getHeaders(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`Failed to update client: ${res.status}`);
    return res.json();
  },

  deleteClient: async (id: string): Promise<void> => {
    const res = await fetch(`${API_BASE_URL}/api/revisr/clients/${id}`, {
      method: 'DELETE',
      headers: await getHeaders(),
    });
    if (!res.ok) throw new Error(`Failed to delete client: ${res.status}`);
  },
};
